// extracted by mini-css-extract-plugin
module.exports = {"rewardButton":"ButtonWithArrow_rewardButton__33aJI","text":"ButtonWithArrow_text__335rv","buttonIcon":"ButtonWithArrow_buttonIcon__ePASr"};